const config = {
  getLogoutUrl() {
    return 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri='
  },

  getClientId() {
    return '90863b26-8fdd-4281-b893-a7974e5b0271'
  },

  getScope() {
    return 'openid+https%3A%2F%2Fgraph.microsoft.com%2Fuser.read%20group.read.all'
  },

  getTenant() {
    return 'sainsburys.co.uk'
  },

  getConsentAdminUrl() {
    return `https://login.microsoftonline.com/${
      this.getTenant()
    }/adminconsent?client_id=${
      this.getClientId()
    }&state=groupaccess&redirect_uri=${
      this.getApplicationUrl()
    }/adminconsent`
  },

  getApplicationUrl() {
    return window.location.origin
  }
}

export { config as default }


// WEBPACK FOOTER //
// ./src/utils/config.js